import React, { useState } from "react";
import Image from "react-bootstrap/Image";
import Lightbox from "react-awesome-lightbox";

const MultiPagePreview = ({ currentImage, setOpen, images }) => {
  return (
    <Lightbox
      startIndex={currentImage}
      onClose={() => setOpen(false)}
      images={images}
      buttonAlign={"center"}
      showTitle
    />
  );
};

const SinglePagePreview = ({ setOpen, image }) => {
  return (
    <Lightbox
      onClose={() => setOpen(false)}
      image={image.url}
      buttonAlign={"center"}
      showTitle
    />
  );
};

const PosterGallery = ({ session, poster }) => {
  const [open, setOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState(0);
  const { pages } = poster;

  const images = pages
    .filter((page) => page.indexOf("mp3") === -1 && page.indexOf("mp4") === -1 && page.indexOf("pptx") === -1) 
    .map((page, idx) => ({
      url: page,
      title: idx + 1,
    }));
  return (
    <>
      <div className="gallery-images">
        {pages
          .filter(
            (page) => page.indexOf("mp3") === -1 && page.indexOf("mp4") === -1 && page.indexOf("pptx") === -1
          )
          .map((image, idx) => (
            <Image
              className="gallery-image"
              thumbnail
              onClick={() => {
                setOpen(true);
                setCurrentImage(idx);
              }}
              key={`${session}-${idx}`}
              src={image}
            />
          ))}
      </div>
      {open &&
        (images.length === 1 ? (
          <SinglePagePreview setOpen={setOpen} image={images[0]} />
        ) : (
          <MultiPagePreview
            startIndex={currentImage}
            setOpen={setOpen}
            images={images}
          />
        ))}
    </>
  );
};

export default PosterGallery;
